export default "__VITE_ASSET__a42c7599__"